import { withTelegramText } from "@/lib/social-links";

export type ContactContext = "arena" | "expert" | "people";

/** Первое слово имени; пусто — null. */
export function firstNameOf(fullName: string | null | undefined): string | null {
  const s = (fullName ?? "").trim().split(/\s+/)[0] ?? "";
  return s || null;
}

/** Готовый черновик сообщения. Без имени обращение/подпись опускаются. */
export function buildContactMessage({
  context,
  recipientName,
  senderName,
}: {
  context: ContactContext;
  recipientName?: string | null;
  senderName?: string | null;
}): string {
  const to = firstNameOf(recipientName);
  const me = firstNameOf(senderName);
  const hi = to ? `Привет, ${to}!` : "Привет!";
  if (context === "arena") {
    const intro = me ? `Это ${me} из TurkeyDrive.` : "Пишу из TurkeyDrive.";
    return `${hi} ${intro} Мы договорились о кофе на ARENA ☕ Когда тебе удобно встретиться? Предлагаю у стенда TurkeyDrive`;
  }
  const intro = me ? `Это ${me}, пишу тебе из TurkeyDrive.` : "Пишу тебе из TurkeyDrive.";
  if (context === "expert") return `${hi} ${intro} Хочу уточнить по твоим услугам: `;
  return `${hi} ${intro.slice(0, -1)} 🐾 Хочется познакомиться`;
}

/** Добавляет ?text= только к Telegram и WhatsApp; прочие ссылки не трогает. */
export function withMessage(url: string, text: string | null | undefined): string {
  if (!text) return url;
  if (/^(https?:\/\/)?(www\.)?(t\.me|telegram\.me|wa\.me|api\.whatsapp\.com)\//i.test(url.trim())) {
    return withTelegramText(url, text);
  }
  return url;
}
